import { useInboxQuestionGroupCardsEnabled } from '@/hooks/inbox/useInboxQuestionGroups';
import { useAbility } from '@/hooks/useAbility';
import type { InboxGrouping } from '@/services/conversations/inbox';

/**
 * Grouping is requested only when the server would allow it and the app wants the cards: the
 * viewer holds the by-question capability and the question-group-card switch is on. Everyone else keeps the
 * flat request and groups on the client, so nothing changes for them. The server enforces the
 * capability too; this only avoids asking for what it would refuse.
 */
export function resolveInboxGrouping(
  canReadByQuestion: boolean,
  questionGroupCardsEnabled: boolean
): InboxGrouping {
  return canReadByQuestion && questionGroupCardsEnabled ? 'question' : 'none';
}

export function useInboxGrouping(): InboxGrouping {
  const ability = useAbility();

  const questionGroupCardsEnabled = useInboxQuestionGroupCardsEnabled();

  return resolveInboxGrouping(ability.can('read', 'InboxByQuestion'), questionGroupCardsEnabled);
}
